import React, { Component } from 'react'

class MobileSideNavBar extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {}
  }

  render() {
    return (
      <div className="vx_globalNav-secondaryNav_mobile">
        <div>
          <p className="vx_h5 vx_globalNav-displayName">
            {this.props.user.displayname}
          </p>
        </div>
        <div className="vx_globalNav-listItem_mobileLogout">
          <a
            href=""
            id="header-logout_mobile"
            name="header-logout_mobile"
            className="vx_globalNav-link_mobileLogout"
            pa-marked="1"
          >
            Log Out
          </a>
        </div>
        <div className="vx_globalNav-listItem_settings hide">
          <a
            href=""
            id="header-settings_mobile"
            name="header-settings_mobile"
            className="vx_globalNav-svgIcon vx_globalNav-link_settings"
          >
            <span className="ppvx_icon ppvx_icon--size_lg ppvx_icon-settings header__icon--color" />
            <span className="vx_a11yText">Settings</span>
          </a>
        </div>
      </div>
    )
  }
}

export default MobileSideNavBar
